import { Button, SizableText, SmartLink, Stack, XStack, YStack, YStackProps, isWeb } from '@my/ui'
import { LinearGradient } from '@tamagui/linear-gradient'
import { SolitoImage } from 'solito/image'
export interface AdLargeProps {
  id: string
  title?: string
  description?: string
  ctaLabel: string
  href: string
  image: {
    url: string
    alt: string
  }
}

export const AdLarge = ({
  image,
  title,
  description,
  ctaLabel,
  href,
  ...props
}: AdLargeProps & YStackProps) => {
  return (
    <YStack pos="relative" p="$3.5" pt="$0" {...props}>
      <Stack aspectRatio={1} overflow="hidden" width="100%" br="$3">
        <SolitoImage
          src={image.url}
          alt={image.alt || title || 'Ad image'}
          contentFit="cover"
          fill
          sizes="(max-width: 900px) 100vw, 568px"
        />
        {isWeb ? (
          <div
            style={{
              backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,.3), transparent)',
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          />
        ) : (
          <LinearGradient
            width="100%"
            height="100%"
            position="absolute"
            bottom="$0"
            left="$0"
            colors={['$backdrop', '$overlay0']}
            start={[0, 1]}
            end={[0, 0]}
          />
        )}
      </Stack>

      <YStack
        pos="absolute"
        jc="flex-end"
        flex={1}
        bottom="$3.5"
        left="$3.5"
        right="$3.5"
        top="$3.5"
        gap="$2"
        p="$3.5"
        $gtXs={{
          gap: '$3.5',
        }}
      >
        <SmartLink
          Component={YStack}
          href={href}
          gap="$3.5"
          flex={1}
          jc="flex-end"
          hoverStyle={{
            opacity: 0.8,
          }}
          pressStyle={{
            opacity: 0.75,
          }}
          focusStyle={{
            opacity: 0.75,
          }}
        >
          <YStack gap="$1">
            {title && (
              <SizableText
                color="$white"
                size="$7.5"
                fow="600"
                numberOfLines={3}
                $gtSm={{ size: '$9', fow: '600' }}
              >
                {title}
              </SizableText>
            )}
            {description && (
              <SizableText size="$3" color="$white" $gtSm={{ size: '$5' }} numberOfLines={2}>
                {description}
              </SizableText>
            )}
          </YStack>
        </SmartLink>

        {ctaLabel && (
          <XStack w="100%">
            <SmartLink Component={Button} href={href} flex={1} theme="black" size="$4">
              {ctaLabel}
            </SmartLink>
          </XStack>
        )}
      </YStack>
    </YStack>
  )
}
